"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationService = void 0;
const typedi_1 = require("typedi");
const html_entities_1 = require("html-entities");
/**
 * Сервис переводов
 */
let TranslationService = class TranslationService {
    constructor() {
        /**
         * Переводы
         */
        this.translations = {};
    }
    /**
     * Возвращает текущий языковой префикс
     */
    getLanguagePrefix() {
        return window.language;
    }
    /**
     * Загружает переводы
     */
    load(map) {
        Object.assign(this.translations, map);
    }
    /**
     * Возвращает перевод
     */
    instant(key) {
        return this.translations[key] && (0, html_entities_1.decode)(this.translations[key], { scope: 'strict' }) || key;
    }
};
TranslationService = __decorate([
    (0, typedi_1.Service)()
], TranslationService);
exports.TranslationService = TranslationService;
